import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "price-tag",
  "use": "price-tag-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"price-tag\">\n<title></title>\n<path d=\"M488 0h-192c-13.2 0-31.637 7.637-40.971 16.971l-238.058 238.058c-9.334 9.334-9.334 24.607 0 33.941l206.059 206.059c9.334 9.334 24.607 9.334 33.941 0l238.059-238.059c9.333-9.333 16.97-27.77 16.97-40.97v-192c0-13.2-10.8-24-24-24zM368 192c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol